module.exports = __webpack_public_path__ + "img/dots_ldb_5.be2aaf02.png";